import React from 'react';
import './Loading.scss';
import Initials from 'components/ui/Initials/Initials';

// Pantalla de carga. Más adelante se puede atar a la espera de la base de datos.
export default function Loading() {
  return (
    <div className="app_loading" translate="no" role="status" aria-live="polite" aria-label="Loading">
      <div className="app_loading_mark">
        <Initials isSidebarExpanded={false} />
      </div>

      <div className="app_loading_bar">
        <span className="app_loading_fill"></span>
      </div>
      <p className="app_loading_label">Loading...</p>
    </div>
  );
}
